// exported form module
import * as actions from './actions'
import * as effects from './effects'
export default { actions, effects }
